import { css } from "@compiled/react";
import { FormattedMessage } from "react-intl";

import Button from "@atlaskit/button";
import { token } from "@atlaskit/tokens";

import { wacToken } from "@/libraries/design/foundations";

import { messages } from "../messages";
import { fontFamily } from "../util";

export const LoggedOutUser = ({
    onLogInClick
}: {
    readonly onLogInClick: () => void;
}) => {
    return (
        <div>
            <Button appearance="subtle" name="sign-in" onClick={onLogInClick}>
                <div css={rootContainer}>
                    <div css={triggerContainer}>
                        <span css={titleLabel}>
                            <FormattedMessage {...messages.logIn} />
                        </span>
                    </div>
                </div>
            </Button>
        </div>
    );
};

const rootContainer = css({
    "&:hover": {
        cursor: "pointer"
    }
});

const triggerContainer = css({
    display: "flex",
    alignItems: "center"
});

const titleLabel = css({
    fontFamily: fontFamily,
    fontSize: token("space.200"),
    color: wacToken("color.extended.blue800")
});
